import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SubmitPaper = () => {
  return (
    <div style={{ paddingTop: '90px' }}>
      <Container>
        <h1 className="mb-4">Submit Your Paper</h1>
        <div className="card shadow-sm p-4">
          <div className="card-body">
            <h3 className="mb-4">Submission Guidelines</h3>
            <p className="lead">
              Welcome to the paper submission portal for Asia-Pacific Academic Press. 
              Please follow the submission guidelines below before submitting your paper.
            </p>
            
            <div className="mt-4">
              <h4>Submission Process</h4>
              <ol className="mt-3">
                <li>Ensure your paper follows our submission guidelines</li>
                <li>Prepare your manuscript according to our template</li>
                <li>Have all author information ready</li>
                <li>Submit through our online system</li>
              </ol>
            </div>

            <div className="mt-4">
              <h4>Important Information</h4>
              <ul className="mt-3">
                <li>All submissions will undergo a peer-review process</li>
                <li>Authors will be notified of the review outcome via email</li>
                <li>There may be publication fees for accepted papers</li>
              </ul>
            </div>

            <div className="mt-5 text-center">
              <Link to="/submission-form" className="btn btn-primary btn-lg px-5">
                Proceed to Submission
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SubmitPaper;
